import React, { useEffect, useState } from 'react';
import logo from '../images/ParcelX_Logo.svg';
import {NavLink } from "react-router-dom";
function Header({item="About", item1="Features", item2="Videsh", item3="Pacex",item4="Career", item5="Courier Partners", item6="Channel Integration", item7="Pricing", item8="Tracking", item9="Contact", nav_button="Sign Up"} , nav_button2="Login") {
    const [scrolled, setScrolled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20); // trigger after 50px scroll
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <div className={`sticky-top ${scrolled ? "header-top" : ""}`}>
            <nav className="navbar navbar-expand-lg navbar-light ">
                <div className="container-fluid px-0">
                    <NavLink className="navbar-brand" onClick={() => setIsOpen(false)} to="/">
                        <img src={logo} className="img-fluid" width={150} alt="Logo" />
                    </NavLink>
                    <button className="navbar-toggler" type="button" onClick={() => setIsOpen(!isOpen)}>
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)} aria-current="page" to="/about">{item}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)}  to="/features">{item1}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)}  to="/parcel-videsh">{item2}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)}  to="/pacex">{item3}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)}  to="/career">{item4}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)}  to="/courier-partners">{item5}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)} to="/channel-integration">{item6}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)} to="/pricing">{item7}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)} to="/tracking">{item8}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={(e)=>{return e.isActive?"nav-active": ""}} onClick={() => setIsOpen(false)} to="/contact-us">{item9}</NavLink>
                            </li>
                            <li className='d-lg-none d-block'>
                                <NavLink  to='https://seller.parcelx.in/login' className="btn btn-secondary me-2" type="submit">{nav_button2}</NavLink>
                                <NavLink  to='https://seller.parcelx.in/register' className="btn btn-primary" type="submit">{nav_button}</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='d-lg-block d-none'>
                        <NavLink  to='https://seller.parcelx.in/login' className="btn btn-secondary me-2" type="submit">{nav_button2}</NavLink>
                        <NavLink  to='https://seller.parcelx.in/register' className="btn btn-primary" type="submit">{nav_button}</NavLink>
                    </div>
                </div>
            </nav> 
        </div>
    );
}

export default Header